import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AccountMenu.css';

// Memes 3 destinations que le menu Parametres (MainNav.jsx:navMenus) — filtrees
// par les memes permissions (company.menu_keys, cf. utils/menuAccess.js) pour
// qu'un compte staff limite ne voie pas ici une page qu'on lui a par ailleurs
// cachee. `permPath` = chemin SANS le `#password` (utilise pour la verification
// de permission uniquement — menu_keys contient le chemin de la page reelle,
// pas l'ancre) ; `path` = destination reelle de la navigation.
const ACCOUNT_ITEMS = [
  { label: 'Profil', path: '/parametres/compte' },
  { label: 'Mot de passe', path: '/parametres/compte#password', permPath: '/parametres/compte' },
  { label: 'Facturation mensuelle', path: '/parametres/facturation' },
];

// Avatar rond (logo de la company) a droite de la nav (MainNav.jsx) — demande
// explicite 2026-09-18. Popover : Profil / Mot de passe (renvoient vers
// /parametres/compte, deja construite — cf. CompanyProfilePage.jsx, qui gere
// deja logo/adresse ET changement de mot de passe sur 2 cartes ; "Mot de
// passe" y ajoute juste #password pour scroller direct sur la bonne carte),
// Facturation mensuelle (nouvelle page dediee), puis Deconnexion — memes
// call/logique que TopBar.jsx (seul autre endroit avec un bouton logout).
const AccountMenu = () => {
  const [open, setOpen] = useState(false);
  const { company, logout } = useAuth();
  const navigate = useNavigate();
  const wrapRef = useRef(null);

  const menuKeys = company?.menu_keys;
  const visibleItems = useMemo(() => {
    if (!Array.isArray(menuKeys)) return ACCOUNT_ITEMS;
    const allowed = new Set(menuKeys);
    return ACCOUNT_ITEMS.filter((item) => allowed.has(item.permPath || item.path));
  }, [menuKeys]);

  useEffect(() => {
    if (!open) return undefined;
    const handleOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [open]);

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    navigate('/login');
  };

  return (
    <div className="am-wrap" ref={wrapRef}>
      <button
        type="button"
        className="am-avatar-btn"
        onClick={() => setOpen((v) => !v)}
        aria-label="Mon compte"
        aria-expanded={open}
      >
        {company?.logo ? (
          <img className="am-avatar-img" src={company.logo} alt="" />
        ) : (
          <span className="am-avatar-fallback">{company?.name?.[0]?.toUpperCase() || '?'}</span>
        )}
      </button>

      {open && (
        <div className="am-popover">
          <div className="am-popover-header">{company?.name}</div>

          {visibleItems.map((item) => (
            <button key={item.path} type="button" className="am-item" onClick={() => go(item.path)}>
              {item.label}
            </button>
          ))}

          <div className="am-divider" />

          <button type="button" className="am-item am-logout" onClick={handleLogout}>
            Deconnexion
          </button>
        </div>
      )}
    </div>
  );
};

export default AccountMenu;
